/**
 * Web HelpPageViewModel Adapter
 * Integrates platform-agnostic HelpPageViewModel with web-specific services
 */

import { useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  createHelpPageViewModel,
  createWebPlatformServices,
  WebHelpPageService,
  type HelpPageViewModel
} from '@restaurant/viewmodels'

/**
 * Create web-specific help page ViewModel
 * Uses React Router for navigation and web platform services
 */
export const useWebHelpPageViewModel = (): HelpPageViewModel => {
  const navigate = useNavigate()
  const location = useLocation()

  // Create web-specific platform services (memoized)
  const platformServices = useMemo(() => {
    return createWebPlatformServices(navigate, location)
  }, [navigate, location])

  // Create web-specific service (memoized to prevent infinite re-renders)
  const helpPageService = useMemo(() => {
    return new WebHelpPageService()
  }, [])

  // Create and return the platform-agnostic HelpPageViewModel
  const HelpPageViewModelHook = useMemo(() => {
    return createHelpPageViewModel(platformServices, { helpPageService })
  }, [platformServices, helpPageService])

  return HelpPageViewModelHook()
}

export default useWebHelpPageViewModel
